// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schoolFilesPage {
  width: 100%;
  min-height: calc(100vh - 76px);
  padding-bottom: 32px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.schoolFilesPage__header {
  display: flex;
  width: calc(100% + 56px);
  min-height: 96px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin: -20px 0 22px -28px;
  padding: 16px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.schoolFilesPage__titleRow {
  display: flex;
  align-items: center;
  gap: 10px;
}

.schoolFilesPage__titleRow h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.15;
}

.schoolFilesPage__titleRow span {
  display: inline-flex;
  min-width: 28px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc) !important;
  color: var(--blue-700, #155d8c) !important;
  font-size: 12px;
  font-weight: 800;
}

.schoolFilesPage .gridPanelTitleRow {
  margin: 0;
}

.schoolFilesPage .gridPanelTitle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 0 12px !important;
  flex-wrap: wrap;
}

.schoolFilesPage .gridPanelTitle > h1 {
  display: none;
}

.schoolFilesPage .gridModernSearch {
  display: inline-flex;
  width: min(360px, 100%);
  flex: 0 1 360px;
  height: 40px;
  align-items: center;
  margin: 0;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
}
.schoolFilesPage .gridModernSearch input { width: 100%; height: 100%; padding: 0; border: 0; outline: 0; background: transparent; }
.schoolFilesPage .gridModernSearch__clear { width: 26px; height: 26px; padding: 0; border: 0; border-radius: 50%; background: transparent; font-size: 20px; }
.schoolFilesPage .gridModernFiltersAnchor,
.schoolFilesPage .gridModernColumns {
  position: relative;
  flex: 0 0 auto;
}
.schoolFilesPage .gridModernFilterButton,
.schoolFilesPage .gridModernColumns > button {
  display: inline-flex !important;
  height: 40px !important;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin: 0 !important;
  padding: 0 13px !important;
  border: 1px solid var(--border-default, #cbd5e1) !important;
  border-radius: 8px !important;
  background: #fff !important;
  color: var(--text-body, #334155) !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}
.schoolFilesPage .gridModernFilterButton:hover,
.schoolFilesPage .gridModernFilterButton.is-active,
.schoolFilesPage .gridModernColumns > button:hover {
  border-color: var(--border-brand, #6fb1df) !important;
  background: var(--blue-50, #eef6fc) !important;
  color: var(--blue-700, #155d8c) !important;
}
.schoolFilesPage .gridModernFilterButton > span,
.schoolFilesPage .gridModernColumns > button > span {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  background: currentColor;
}
.schoolFilesPage .gridModernFilterButton > span {
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E") center/16px no-repeat;
}
.schoolFilesPage .gridModernColumns > button > span {
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E") center/16px no-repeat;
}
.schoolFilesPage .gridModernFilterButton b,
.schoolFilesPage .gridModernColumns > button b {
  display: inline-flex;
  min-width: 19px;
  height: 19px;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 10.5px;
}
.schoolFilesPage .gridModernFilterButton.is-active b {
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.schoolFilesPage .gridModernFilterPopover {
  position: fixed;
  z-index: 2147483001;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  flex-direction: column;
  margin: 0;
  border: 0;
  border-left: 1px solid var(--border-subtle, #d9e2ec);
  border-radius: 0;
  background: var(--surface-card, #fff);
  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);
}

.schoolFilesPage .gridModernFilterPopover > header {
  display: flex;
  min-height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  margin: 18px 18px 0 !important;
  padding: 0 0 12px !important;
  border-bottom: 1px solid var(--border-subtle, #e6ebf1);
}

.schoolFilesPage .gridModernFilterPopover > header strong {
  color: var(--text-strong, #172b4d);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 16px;
  font-weight: 800;
}

.schoolFilesPage .gridModernFilterPopover > header button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-muted, #667085);
  font-size: 23px;
  line-height: 1;
  cursor: pointer;
}

.schoolFilesPage .gridModernFilterPopover > header button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #172b4d);
}

.schoolFilesPage .gridModernFilterPopover__fields {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 18px;
  padding: 18px 18px 24px;
  overflow-x: hidden;
  overflow-y: auto;
}

.schoolFilesPage .gridModernFilterPopover__fields > label {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 7px;
  margin: 0;
}

.schoolFilesPage .gridModernFilterPopover__fields > label > span,
.schoolFilesPage .gridModernFilterPopover .gridModernFilterChips legend,
.schoolFilesPage .gridModernFilterPopover .sit-dp__label {
  margin: 0;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.schoolFilesPage .gridModernFilterPopover__fields input,
.schoolFilesPage .gridModernFilterPopover__fields select,
.schoolFilesPage .gridModernFilterPopover .sit-dp__trigger {
  width: 100%;
  min-height: 40px;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background-color: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  box-shadow: none;
}

.schoolFilesPage .gridModernFilterPopover__fields select {
  padding-right: 32px;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
}

.schoolFilesPage .gridModernFilterPopover__fields input:focus,
.schoolFilesPage .gridModernFilterPopover__fields select:focus,
.schoolFilesPage .gridModernFilterPopover .sit-dp__trigger:focus-within {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));
}

.schoolFilesPage .gridModernFilterChips {
  margin: 0;
  padding: 0;
  border: 0;
}

.schoolFilesPage .gridModernFilterChips > div {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.schoolFilesPage .gridModernFilterChips button {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.schoolFilesPage .gridModernFilterChips button:hover {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
}

.schoolFilesPage .gridModernFilterChips button.is-selected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.schoolFilesPage .gridModernFilterPopover > footer {
  display: flex;
  min-height: 69px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  padding: 14px 18px;
  border-top: 1px solid var(--border-subtle, #e6ebf1);
  background: var(--surface-card, #fff);
}

.schoolFilesPage .gridModernFilterPopover > footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.schoolFilesPage .gridModernFilterPopover > footer button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  padding: 0 13px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.schoolFilesPage .gridModernFilterPopover > footer button.is-clear {
  padding: 0;
  border-color: transparent;
  background: transparent;
  color: var(--text-link, #1a6da3);
}

.schoolFilesPage .gridModernFilterPopover > footer button.is-apply {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.schoolFilesPage .gridModernFilterPopover > footer button.is-apply:hover {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
}

.schoolFilesPage .gridModernFilterPopover .sit-dp__pop {
  position: fixed;
  z-index: 2147483002;
  top: 50%;
  right: auto;
  left: 50%;
  transform: translate(-50%, -50%);
}

.schoolFilesPage .gridModernColumns__menu {
  position: absolute;
  z-index: 1070;
  top: 46px;
  right: 0;
  width: 260px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
}

.schoolFilesPage .gridModernColumns__menu header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 8px 9px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.schoolFilesPage .gridModernColumns__menu header button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.schoolFilesPage .gridModernColumns__menu label {
  display: flex;
  min-height: 34px;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 7px 8px;
  border-radius: 6px;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.schoolFilesPage .gridModernColumns__menu label:hover {
  background: var(--surface-page, #f8fafc);
}

.schoolFilesPage .gridModernColumns__menu input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--action-primary, #227ebd);
}

.schoolFilesPage table .custom-checkbox input[type='checkbox'],
.schoolFilesPage .selectAllCheckbox > input[type='checkbox'] {
  position: relative;
  display: block;
  width: 16px;
  height: 16px;
  margin: 0 !important;
  appearance: none;
  -webkit-appearance: none;
  border: 1.5px solid var(--border-strong, #aebaca);
  border-radius: 4px;
  outline: none;
  background: var(--surface-card, #fff);
  box-shadow: none;
  cursor: pointer;
}

.schoolFilesPage table .custom-checkbox input[type='checkbox']:hover,
.schoolFilesPage .selectAllCheckbox > input[type='checkbox']:hover {
  border-color: var(--action-primary, #227ebd);
}

.schoolFilesPage table .custom-checkbox input[type='checkbox']:focus-visible,
.schoolFilesPage .selectAllCheckbox > input[type='checkbox']:focus-visible {
  border-color: var(--action-primary, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.18);
}

.schoolFilesPage table .custom-checkbox input[type='checkbox']:checked,
.schoolFilesPage .selectAllCheckbox > input[type='checkbox']:checked {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}

.schoolFilesPage table .custom-checkbox input[type='checkbox']:checked::after,
.schoolFilesPage .selectAllCheckbox > input[type='checkbox']:checked::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 1.5px 1.5px 0;
  transform: rotate(45deg);
}

.schoolFilesPage .gridActiveFilters {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  padding: 0 0 12px;
}

.schoolFilesPage .gridActiveFilters > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 12px;
}

.schoolFilesPage .gridActiveFilters > span > button {
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  margin: 0 -3px 0 2px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: currentColor;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.schoolFilesPage .gridActiveFilters > span > button:hover {
  background: rgba(21, 93, 140, 0.12);
}

.schoolFilesPage .gridActiveFilters > button {
  padding: 0 4px;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.schoolFilesPage .gridTableActions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 8px 14px;
  flex-wrap: wrap;
  border: 1px solid var(--blue-100, #cfe5f2);
  border-radius: 8px;
  background: var(--blue-50, #eef6fc);
}
.schoolFilesPage .gridTableActions > span { color: var(--blue-700, #155d8c); font-size: 13px; font-weight: 600; }
.schoolFilesPage .gridTableActions > div { display: flex; flex-wrap: wrap; gap: 7px; }
.schoolFilesPage .gridTableActions button {
  display: inline-flex !important;
  min-height: 32px !important;
  align-items: center;
  padding: 0 11px !important;
  border: 1px solid var(--border-default, #cbd5e1) !important;
  border-radius: 8px !important;
  background: #fff !important;
  color: var(--text-body, #334155) !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}
.schoolFilesPage .gridTableActions button.is-danger {
  border-color: var(--red-600, #c4313f) !important;
  background: var(--red-600, #c4313f) !important;
  color: #fff !important;
}

.schoolFilesPage__header p {
  margin: 6px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.45;
}
.schoolFilesPage__tabs {
  display: flex;
  gap: 22px;
  margin-top: 14px;
}
.schoolFilesPage__tabs button {
  position: relative;
  min-height: 32px;
  padding: 0 1px;
  border: 0;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.schoolFilesPage__tabs button.isActive { color: var(--action-primary, #227ebd); }
.schoolFilesPage__tabs button.isActive::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: -16px;
  left: 0;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--action-primary, #227ebd);
}
.schoolFilesPage__tabs span {
  display: inline-flex;
  min-width: 19px;
  height: 19px;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  font-size: 10.5px;
}

.schoolFilesPage__create {
  display: inline-flex;
  min-height: 40px;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  padding: 0 15px;
  border: 1px solid var(--action-primary, #227ebd);
  border-radius: 8px;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.schoolFilesPage__create:hover {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
}

.schoolFilesPage__mainCard {
  width: 100%;
  padding: 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.06);
}

.schoolFilesPage__mainCard .gridPanelModern {
  margin: 0;
}

.schoolFileEditorModal .modal-content {
  border: 1px solid var(--border-subtle, #e2e8f0) !important;
  border-radius: 14px !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.2) !important;
}

.schoolFileEditorModal .modal-header,
.schoolFileEditorModal .modal-body {
  padding: 18px 20px !important;
}

.schoolFileEditor {
  color: var(--text-body, #334155);
}

.schoolFileEditor__field {
  display: block;
  margin: 0 0 16px;
}

.schoolFileEditor__field > span {
  display: block;
  margin-bottom: 6px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}

.schoolFileEditor__field input:not([type='file']),
.schoolFileEditor__field select {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  outline: 0;
  background: #fff;
  color: var(--text-strong, #0f172a);
  font: inherit;
}

.schoolFileEditor__field input:focus,
.schoolFileEditor__field select:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.schoolFileEditor__upload {
  position: relative;
  display: flex;
  min-height: 92px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 16px;
  border: 1px dashed var(--border-default, #cbd5e1);
  border-radius: 10px;
  background: var(--slate-25, #fafbfc);
  color: var(--action-primary, #227ebd);
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.schoolFileEditor__upload:hover {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
}
.schoolFileEditor__upload b { font-size: 13px; }
.schoolFileEditor__upload small { margin-top: 4px; color: var(--text-muted, #64748b); font-size: 12px; }
.schoolFileEditor__upload input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.schoolFileEditor__upload.isError { border-color: var(--red-500, #da4453); }
.schoolFileEditor__upload.isUploading { cursor: wait; opacity: 0.75; }
.schoolFileEditor__uploadedFile {
  display: flex;
  min-height: 38px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 8px;
  padding: 7px 8px 7px 11px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 650;
}
.schoolFileEditor__uploadedFile button {
  width: 26px;
  height: 26px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 18px;
  cursor: pointer;
}
.schoolFileEditor__uploadedFile button:hover { background: var(--surface-sunken, #f1f5f9); }

.schoolFileEditor__field em,
.schoolFileEditor__field small {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  font-style: normal;
}

.schoolFileEditor__field em { color: var(--red-600, #c4313f); }
.schoolFileEditor__field small { color: var(--green-700, #287a50); }

.schoolFileEditor__publish {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 16px;
  padding: 12px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 9px;
  background: var(--slate-25, #fafbfc);
}

.schoolFileEditor__publish strong,
.schoolFileEditor__publish span {
  display: block;
}
.schoolFileEditor__publish strong { color: var(--text-strong, #0f172a); font-size: 13px; }
.schoolFileEditor__publish span { margin-top: 2px; color: var(--text-muted, #64748b); font-size: 12px; }

.schoolFileEditor__actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.schoolFileEditor__actions button {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.schoolFileEditor__actions button.isPrimary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.schoolFileEditor__actions button:disabled { cursor: not-allowed; opacity: 0.55; }

.schoolFilesDeleteModal .modal-footer .btn-primary {
  border-color: var(--red-600, #c4313f) !important;
  background: var(--red-600, #c4313f) !important;
  color: #fff !important;
}

.schoolFileCategoryDeleteModal .modal-footer .btn-primary {
  border-color: var(--red-600, #c4313f) !important;
  background: var(--red-600, #c4313f) !important;
  color: #fff !important;
}

.schoolFileCategoryModal .modal-content {
  overflow: hidden !important;
  border: 1px solid var(--border-subtle, #e2e8f0) !important;
  border-radius: 14px !important;
}

.schoolFileCategoryModal .modal-body {
  padding: 20px 22px !important;
  overflow-x: hidden !important;
}

.schoolFileCategoryModal .modal-body > div,
.schoolFileCategoryModal__body,
.schoolFileCategoryModal__body * {
  max-width: 100%;
  box-sizing: border-box;
}

.schoolFileCategoryModal .modal-footer {
  gap: 8px !important;
  padding: 14px 22px !important;
  border-top: 1px solid var(--border-subtle, #e2e8f0) !important;
  background: var(--surface-card, #fff) !important;
}

.schoolFileCategoryModal .modal-footer .btn {
  min-height: 38px !important;
  padding: 0 14px !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}

.schoolFileCategoryModal .modal-footer .btn-secondary:not(:disabled) {
  border-color: var(--border-default, #cbd5e1) !important;
  background: var(--surface-card, #fff) !important;
  color: var(--text-body, #334155) !important;
}

.schoolFileCategoryModal .modal-footer .btn-secondary:not(:disabled):hover {
  border-color: var(--border-brand, #6fb1df) !important;
  background: var(--blue-50, #eef6fc) !important;
  color: var(--blue-700, #155d8c) !important;
}

.schoolFileCategoryModal .modal-footer .btn-primary:not(:disabled) {
  border-color: var(--action-primary, #227ebd) !important;
  background: var(--action-primary, #227ebd) !important;
  color: #fff !important;
}

.schoolFileCategoryModal .modal-footer .btn-primary:not(:disabled):hover {
  border-color: var(--blue-600, #1a6da3) !important;
  background: var(--blue-600, #1a6da3) !important;
}

.schoolFileCategories__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding-bottom: 14px;
}
.schoolFileCategories__toolbar strong,
.schoolFileCategories__toolbar span { display: block; }
.schoolFileCategories__toolbar strong { color: var(--text-strong, #0f172a); font-size: 15px; }
.schoolFileCategories__toolbar span { margin-top: 3px; color: var(--text-muted, #64748b); font-size: 12px; }
.schoolFileCategories__toolbar > button {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid var(--action-primary, #227ebd);
  border-radius: 8px;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.schoolFileCategories__tableWrap { overflow: visible; border: 1px solid var(--border-subtle, #e2e8f0); border-radius: 10px; }
.schoolFileCategories table { width: 100%; border-collapse: separate; border-spacing: 0; }
.schoolFileCategories th { padding: 11px 14px; border-bottom: 1px solid var(--border-subtle, #e2e8f0); background: var(--slate-25, #fafbfc); color: var(--text-muted, #64748b); font-size: 11px; font-weight: 800; text-align: left; text-transform: uppercase; }
.schoolFileCategories td { height: 56px; padding: 10px 14px; border-bottom: 1px solid var(--border-subtle, #e2e8f0); font-size: 13px; }
.schoolFileCategories tr:last-child td { border-bottom: 0; }
.schoolFileCategories tbody tr { cursor: pointer; }
.schoolFileCategories tbody tr:hover { background: var(--slate-25, #fafbfc); }
.schoolFileCategories tbody .schoolFileCategories__emptyRow { cursor: default; }
.schoolFileCategories tbody .schoolFileCategories__emptyRow:hover { background: #fff; }
.schoolFileCategories td:first-child strong,
.schoolFileCategories td:first-child small { display: block; }
.schoolFileCategories td:first-child strong { color: var(--text-strong, #0f172a); }
.schoolFileCategories td:first-child small { margin-top: 2px; color: var(--text-subtle, #94a3b8); font-size: 10.5px; }
.schoolFileCategories td:nth-child(2) span { display: inline-flex; padding: 4px 9px; border-radius: 999px; background: var(--surface-sunken, #f1f5f9); color: var(--text-muted, #64748b); font-size: 12px; font-weight: 700; }
.schoolFileCategories td:nth-child(2) span.isPublished { background: var(--green-50, #edf8f2); color: var(--green-700, #287a50); }
.schoolFileCategories td:last-child { width: 1%; white-space: nowrap; text-align: right; }
.schoolFileCategories td:last-child button { min-height: 32px; margin-left: 6px; padding: 0 11px; border: 1px solid var(--border-default, #cbd5e1); border-radius: 8px; background: #fff; color: var(--text-body, #334155); font-size: 12px; font-weight: 700; }
.schoolFileCategories td:last-child button.isDanger { color: var(--red-600, #c4313f); }
.schoolFileCategoryModal__body label { display: block; margin: 0; }
.schoolFileCategoryModal__body label > span { display: block; margin-bottom: 6px; color: var(--text-muted, #64748b); font-size: 12px; font-weight: 700; }
.schoolFileCategoryModal__body input[type='text'],
.schoolFileCategoryModal__body label:first-child input { width: 100%; height: 40px; padding: 0 12px; border: 1px solid var(--border-default, #cbd5e1); border-radius: 8px; outline: 0; }
.schoolFileCategoryModal__body input[type='text']:focus { border-color: var(--border-brand, #6fb1df); box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16)); }
.schoolFileCategoryModal__visibility { display: flex !important; align-items: center; gap: 10px; margin-top: 16px !important; padding: 12px; border: 1px solid var(--border-subtle, #e2e8f0); border-radius: 9px; background: var(--slate-25, #fafbfc); }
.schoolFileCategoryModal__visibility > span { margin: 0 !important; }
.schoolFileCategoryModal__visibility strong,
.schoolFileCategoryModal__visibility small { display: block; }
.schoolFileCategoryModal__visibility strong { color: var(--text-strong, #0f172a); font-size: 13px; }
.schoolFileCategoryModal__visibility small { margin-top: 2px; color: var(--text-muted, #64748b); font-size: 12px; font-weight: 500; }

@media (max-width: 760px) {
  .schoolFilesPage__header {
    width: calc(100% + 32px);
    min-height: 0;
    align-items: flex-start;
    flex-direction: column;
    margin-left: -16px;
    padding: 16px;
  }

  .schoolFilesPage .gridModernSearch {
    width: 100%;
    flex-basis: 100%;
  }

  .schoolFilesPage .gridModernFilterPopover {
    width: 100vw;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/AdminConsole/SchoolFiles/SchoolFiles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;EACpB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,8CAA8C;EAC9C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;AACA,2CAA2C,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,SAAS,EAAE,UAAU,EAAE,uBAAuB,EAAE;AAClI,4CAA4C,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,SAAS,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,eAAe,EAAE;AAC5J;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,0BAA0B;EAC1B,2DAA2D;EAC3D,6BAA6B;EAC7B,2BAA2B;EAC3B,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;;;EAGE,qDAAqD;EACrD,8CAA8C;EAC9C,0CAA0C;AAC5C;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,8NAA8N;AAChO;AACA;EACE,gSAAgS;AAClS;AACA;;EAEE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,oDAAoD;EACpD,gBAAgB;EAChB,qCAAqC;EACrC,wFAAwF;AAC1F;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,sDAAsD;AACxD;;AAEA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;;AAEA;;;EAGE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wQAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;;;EAGE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4CAA4C;AAC9C;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;;EAEE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,mCAAmC;AACrC;AACA,4CAA4C,+BAA+B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChH,2CAA2C,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AACrF;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;EACnB,0BAA0B;EAC1B,2DAA2D;EAC3D,6BAA6B;EAC7B,2BAA2B;EAC3B,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,yCAAyC,qCAAqC,EAAE;AAChF;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0DAA0D;EAC1D,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;AACf;;AAEA;;EAEE,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;AACA,8BAA8B,eAAe,EAAE;AAC/C,kCAAkC,eAAe,EAAE,iCAAiC,EAAE,eAAe,EAAE;AACvG;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;AACA,oCAAoC,qCAAqC,EAAE;AAC3E,wCAAwC,YAAY,EAAE,aAAa,EAAE;AACrE;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;AACA,+CAA+C,0CAA0C,EAAE;;AAE3F;;EAEE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,8BAA8B,8BAA8B,EAAE;AAC9D,iCAAiC,gCAAgC,EAAE;;AAEnE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;AACA,oCAAoC,kCAAkC,EAAE,eAAe,EAAE;AACzF,kCAAkC,eAAe,EAAE,iCAAiC,EAAE,eAAe,EAAE;;AAEvG;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA,6CAA6C,mBAAmB,EAAE,aAAa,EAAE;;AAEjF;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0DAA0D;EAC1D,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;;;EAGE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,8DAA8D;EAC9D,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,uDAAuD;EACvD,gDAAgD;EAChD,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;AACA;sCACsC,cAAc,EAAE;AACtD,wCAAwC,kCAAkC,EAAE,eAAe,EAAE;AAC7F,sCAAsC,eAAe,EAAE,iCAAiC,EAAE,eAAe,EAAE;AAC3G;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,mCAAmC,iBAAiB,EAAE,+CAA+C,EAAE,mBAAmB,EAAE;AAC5H,8BAA8B,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AACzF,2BAA2B,kBAAkB,EAAE,sDAAsD,EAAE,oCAAoC,EAAE,iCAAiC,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AAChQ,2BAA2B,YAAY,EAAE,kBAAkB,EAAE,sDAAsD,EAAE,eAAe,EAAE;AACtI,yCAAyC,gBAAgB,EAAE;AAC3D,iCAAiC,eAAe,EAAE;AAClD,uCAAuC,oCAAoC,EAAE;AAC7E,8DAA8D,eAAe,EAAE;AAC/E,oEAAoE,gBAAgB,EAAE;AACtF;6CAC6C,cAAc,EAAE;AAC7D,8CAA8C,kCAAkC,EAAE;AAClF,6CAA6C,eAAe,EAAE,kCAAkC,EAAE,iBAAiB,EAAE;AACrH,6CAA6C,oBAAoB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,0CAA0C,EAAE,iCAAiC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7N,yDAAyD,oCAAoC,EAAE,gCAAgC,EAAE;AACjI,sCAAsC,SAAS,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AACzF,6CAA6C,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE,gDAAgD,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gCAAgC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/P,sDAAsD,8BAA8B,EAAE;AACtF,uCAAuC,cAAc,EAAE,SAAS,EAAE;AAClE,8CAA8C,cAAc,EAAE,kBAAkB,EAAE,iCAAiC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxJ;yDACyD,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,gDAAgD,EAAE,kBAAkB,EAAE,UAAU,EAAE;AACvL,0DAA0D,0CAA0C,EAAE,mEAAmE,EAAE;AAC3K,uCAAuC,wBAAwB,EAAE,mBAAmB,EAAE,SAAS,EAAE,2BAA2B,EAAE,aAAa,EAAE,+CAA+C,EAAE,kBAAkB,EAAE,oCAAoC,EAAE;AACxP,8CAA8C,oBAAoB,EAAE;AACpE;6CAC6C,cAAc,EAAE;AAC7D,8CAA8C,kCAAkC,EAAE,eAAe,EAAE;AACnG,6CAA6C,eAAe,EAAE,iCAAiC,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEpI;EACE;IACE,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".schoolFilesPage {\n  width: 100%;\n  min-height: calc(100vh - 76px);\n  padding-bottom: 32px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.schoolFilesPage__header {\n  display: flex;\n  width: calc(100% + 56px);\n  min-height: 96px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin: -20px 0 22px -28px;\n  padding: 16px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.schoolFilesPage__titleRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.schoolFilesPage__titleRow h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.15;\n}\n\n.schoolFilesPage__titleRow span {\n  display: inline-flex;\n  min-width: 28px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc) !important;\n  color: var(--blue-700, #155d8c) !important;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.schoolFilesPage .gridPanelTitleRow {\n  margin: 0;\n}\n\n.schoolFilesPage .gridPanelTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 0 12px !important;\n  flex-wrap: wrap;\n}\n\n.schoolFilesPage .gridPanelTitle > h1 {\n  display: none;\n}\n\n.schoolFilesPage .gridModernSearch {\n  display: inline-flex;\n  width: min(360px, 100%);\n  flex: 0 1 360px;\n  height: 40px;\n  align-items: center;\n  margin: 0;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n}\n.schoolFilesPage .gridModernSearch input { width: 100%; height: 100%; padding: 0; border: 0; outline: 0; background: transparent; }\n.schoolFilesPage .gridModernSearch__clear { width: 26px; height: 26px; padding: 0; border: 0; border-radius: 50%; background: transparent; font-size: 20px; }\n.schoolFilesPage .gridModernFiltersAnchor,\n.schoolFilesPage .gridModernColumns {\n  position: relative;\n  flex: 0 0 auto;\n}\n.schoolFilesPage .gridModernFilterButton,\n.schoolFilesPage .gridModernColumns > button {\n  display: inline-flex !important;\n  height: 40px !important;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  margin: 0 !important;\n  padding: 0 13px !important;\n  border: 1px solid var(--border-default, #cbd5e1) !important;\n  border-radius: 8px !important;\n  background: #fff !important;\n  color: var(--text-body, #334155) !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n}\n.schoolFilesPage .gridModernFilterButton:hover,\n.schoolFilesPage .gridModernFilterButton.is-active,\n.schoolFilesPage .gridModernColumns > button:hover {\n  border-color: var(--border-brand, #6fb1df) !important;\n  background: var(--blue-50, #eef6fc) !important;\n  color: var(--blue-700, #155d8c) !important;\n}\n.schoolFilesPage .gridModernFilterButton > span,\n.schoolFilesPage .gridModernColumns > button > span {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  background: currentColor;\n}\n.schoolFilesPage .gridModernFilterButton > span {\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\") center/16px no-repeat;\n}\n.schoolFilesPage .gridModernColumns > button > span {\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\") center/16px no-repeat;\n}\n.schoolFilesPage .gridModernFilterButton b,\n.schoolFilesPage .gridModernColumns > button b {\n  display: inline-flex;\n  min-width: 19px;\n  height: 19px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 10.5px;\n}\n.schoolFilesPage .gridModernFilterButton.is-active b {\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.schoolFilesPage .gridModernFilterPopover {\n  position: fixed;\n  z-index: 2147483001;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  flex-direction: column;\n  margin: 0;\n  border: 0;\n  border-left: 1px solid var(--border-subtle, #d9e2ec);\n  border-radius: 0;\n  background: var(--surface-card, #fff);\n  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.schoolFilesPage .gridModernFilterPopover > header {\n  display: flex;\n  min-height: 34px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  margin: 18px 18px 0 !important;\n  padding: 0 0 12px !important;\n  border-bottom: 1px solid var(--border-subtle, #e6ebf1);\n}\n\n.schoolFilesPage .gridModernFilterPopover > header strong {\n  color: var(--text-strong, #172b4d);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.schoolFilesPage .gridModernFilterPopover > header button {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-muted, #667085);\n  font-size: 23px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.schoolFilesPage .gridModernFilterPopover > header button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #172b4d);\n}\n\n.schoolFilesPage .gridModernFilterPopover__fields {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 18px;\n  padding: 18px 18px 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.schoolFilesPage .gridModernFilterPopover__fields > label {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 7px;\n  margin: 0;\n}\n\n.schoolFilesPage .gridModernFilterPopover__fields > label > span,\n.schoolFilesPage .gridModernFilterPopover .gridModernFilterChips legend,\n.schoolFilesPage .gridModernFilterPopover .sit-dp__label {\n  margin: 0;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.schoolFilesPage .gridModernFilterPopover__fields input,\n.schoolFilesPage .gridModernFilterPopover__fields select,\n.schoolFilesPage .gridModernFilterPopover .sit-dp__trigger {\n  width: 100%;\n  min-height: 40px;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background-color: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  box-shadow: none;\n}\n\n.schoolFilesPage .gridModernFilterPopover__fields select {\n  padding-right: 32px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n}\n\n.schoolFilesPage .gridModernFilterPopover__fields input:focus,\n.schoolFilesPage .gridModernFilterPopover__fields select:focus,\n.schoolFilesPage .gridModernFilterPopover .sit-dp__trigger:focus-within {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));\n}\n\n.schoolFilesPage .gridModernFilterChips {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.schoolFilesPage .gridModernFilterChips > div {\n  display: flex;\n  gap: 7px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.schoolFilesPage .gridModernFilterChips button {\n  min-height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.schoolFilesPage .gridModernFilterChips button:hover {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n}\n\n.schoolFilesPage .gridModernFilterChips button.is-selected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.schoolFilesPage .gridModernFilterPopover > footer {\n  display: flex;\n  min-height: 69px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: auto;\n  padding: 14px 18px;\n  border-top: 1px solid var(--border-subtle, #e6ebf1);\n  background: var(--surface-card, #fff);\n}\n\n.schoolFilesPage .gridModernFilterPopover > footer > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.schoolFilesPage .gridModernFilterPopover > footer button {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 13px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.schoolFilesPage .gridModernFilterPopover > footer button.is-clear {\n  padding: 0;\n  border-color: transparent;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n}\n\n.schoolFilesPage .gridModernFilterPopover > footer button.is-apply {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.schoolFilesPage .gridModernFilterPopover > footer button.is-apply:hover {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n}\n\n.schoolFilesPage .gridModernFilterPopover .sit-dp__pop {\n  position: fixed;\n  z-index: 2147483002;\n  top: 50%;\n  right: auto;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.schoolFilesPage .gridModernColumns__menu {\n  position: absolute;\n  z-index: 1070;\n  top: 46px;\n  right: 0;\n  width: 260px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);\n}\n\n.schoolFilesPage .gridModernColumns__menu header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 8px 9px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.schoolFilesPage .gridModernColumns__menu header button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.schoolFilesPage .gridModernColumns__menu label {\n  display: flex;\n  min-height: 34px;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  padding: 7px 8px;\n  border-radius: 6px;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.schoolFilesPage .gridModernColumns__menu label:hover {\n  background: var(--surface-page, #f8fafc);\n}\n\n.schoolFilesPage .gridModernColumns__menu input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.schoolFilesPage table .custom-checkbox input[type='checkbox'],\n.schoolFilesPage .selectAllCheckbox > input[type='checkbox'] {\n  position: relative;\n  display: block;\n  width: 16px;\n  height: 16px;\n  margin: 0 !important;\n  appearance: none;\n  -webkit-appearance: none;\n  border: 1.5px solid var(--border-strong, #aebaca);\n  border-radius: 4px;\n  outline: none;\n  background: var(--surface-card, #fff);\n  box-shadow: none;\n  cursor: pointer;\n}\n\n.schoolFilesPage table .custom-checkbox input[type='checkbox']:hover,\n.schoolFilesPage .selectAllCheckbox > input[type='checkbox']:hover {\n  border-color: var(--action-primary, #227ebd);\n}\n\n.schoolFilesPage table .custom-checkbox input[type='checkbox']:focus-visible,\n.schoolFilesPage .selectAllCheckbox > input[type='checkbox']:focus-visible {\n  border-color: var(--action-primary, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.18);\n}\n\n.schoolFilesPage table .custom-checkbox input[type='checkbox']:checked,\n.schoolFilesPage .selectAllCheckbox > input[type='checkbox']:checked {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n\n.schoolFilesPage table .custom-checkbox input[type='checkbox']:checked::after,\n.schoolFilesPage .selectAllCheckbox > input[type='checkbox']:checked::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 5px;\n  width: 4px;\n  height: 8px;\n  border: solid #fff;\n  border-width: 0 1.5px 1.5px 0;\n  transform: rotate(45deg);\n}\n\n.schoolFilesPage .gridActiveFilters {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n  padding: 0 0 12px;\n}\n\n.schoolFilesPage .gridActiveFilters > span {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 4px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n}\n\n.schoolFilesPage .gridActiveFilters > span > button {\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  margin: 0 -3px 0 2px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: currentColor;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.schoolFilesPage .gridActiveFilters > span > button:hover {\n  background: rgba(21, 93, 140, 0.12);\n}\n\n.schoolFilesPage .gridActiveFilters > button {\n  padding: 0 4px;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.schoolFilesPage .gridTableActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px;\n  padding: 8px 14px;\n  flex-wrap: wrap;\n  border: 1px solid var(--blue-100, #cfe5f2);\n  border-radius: 8px;\n  background: var(--blue-50, #eef6fc);\n}\n.schoolFilesPage .gridTableActions > span { color: var(--blue-700, #155d8c); font-size: 13px; font-weight: 600; }\n.schoolFilesPage .gridTableActions > div { display: flex; flex-wrap: wrap; gap: 7px; }\n.schoolFilesPage .gridTableActions button {\n  display: inline-flex !important;\n  min-height: 32px !important;\n  align-items: center;\n  padding: 0 11px !important;\n  border: 1px solid var(--border-default, #cbd5e1) !important;\n  border-radius: 8px !important;\n  background: #fff !important;\n  color: var(--text-body, #334155) !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n}\n.schoolFilesPage .gridTableActions button.is-danger {\n  border-color: var(--red-600, #c4313f) !important;\n  background: var(--red-600, #c4313f) !important;\n  color: #fff !important;\n}\n\n.schoolFilesPage__header p {\n  margin: 6px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.45;\n}\n.schoolFilesPage__tabs {\n  display: flex;\n  gap: 22px;\n  margin-top: 14px;\n}\n.schoolFilesPage__tabs button {\n  position: relative;\n  min-height: 32px;\n  padding: 0 1px;\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.schoolFilesPage__tabs button.isActive { color: var(--action-primary, #227ebd); }\n.schoolFilesPage__tabs button.isActive::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  bottom: -16px;\n  left: 0;\n  height: 3px;\n  border-radius: 3px 3px 0 0;\n  background: var(--action-primary, #227ebd);\n}\n.schoolFilesPage__tabs span {\n  display: inline-flex;\n  min-width: 19px;\n  height: 19px;\n  align-items: center;\n  justify-content: center;\n  margin-left: 4px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  font-size: 10.5px;\n}\n\n.schoolFilesPage__create {\n  display: inline-flex;\n  min-height: 40px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 8px;\n  padding: 0 15px;\n  border: 1px solid var(--action-primary, #227ebd);\n  border-radius: 8px;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.schoolFilesPage__create:hover {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n}\n\n.schoolFilesPage__mainCard {\n  width: 100%;\n  padding: 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.06);\n}\n\n.schoolFilesPage__mainCard .gridPanelModern {\n  margin: 0;\n}\n\n.schoolFileEditorModal .modal-content {\n  border: 1px solid var(--border-subtle, #e2e8f0) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.2) !important;\n}\n\n.schoolFileEditorModal .modal-header,\n.schoolFileEditorModal .modal-body {\n  padding: 18px 20px !important;\n}\n\n.schoolFileEditor {\n  color: var(--text-body, #334155);\n}\n\n.schoolFileEditor__field {\n  display: block;\n  margin: 0 0 16px;\n}\n\n.schoolFileEditor__field > span {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.schoolFileEditor__field input:not([type='file']),\n.schoolFileEditor__field select {\n  width: 100%;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  outline: 0;\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n}\n\n.schoolFileEditor__field input:focus,\n.schoolFileEditor__field select:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.schoolFileEditor__upload {\n  position: relative;\n  display: flex;\n  min-height: 92px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 16px;\n  border: 1px dashed var(--border-default, #cbd5e1);\n  border-radius: 10px;\n  background: var(--slate-25, #fafbfc);\n  color: var(--action-primary, #227ebd);\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n.schoolFileEditor__upload:hover {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n}\n.schoolFileEditor__upload b { font-size: 13px; }\n.schoolFileEditor__upload small { margin-top: 4px; color: var(--text-muted, #64748b); font-size: 12px; }\n.schoolFileEditor__upload input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n}\n.schoolFileEditor__upload.isError { border-color: var(--red-500, #da4453); }\n.schoolFileEditor__upload.isUploading { cursor: wait; opacity: 0.75; }\n.schoolFileEditor__uploadedFile {\n  display: flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 8px;\n  padding: 7px 8px 7px 11px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 650;\n}\n.schoolFileEditor__uploadedFile button {\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 18px;\n  cursor: pointer;\n}\n.schoolFileEditor__uploadedFile button:hover { background: var(--surface-sunken, #f1f5f9); }\n\n.schoolFileEditor__field em,\n.schoolFileEditor__field small {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  font-style: normal;\n}\n\n.schoolFileEditor__field em { color: var(--red-600, #c4313f); }\n.schoolFileEditor__field small { color: var(--green-700, #287a50); }\n\n.schoolFileEditor__publish {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 9px;\n  background: var(--slate-25, #fafbfc);\n}\n\n.schoolFileEditor__publish strong,\n.schoolFileEditor__publish span {\n  display: block;\n}\n.schoolFileEditor__publish strong { color: var(--text-strong, #0f172a); font-size: 13px; }\n.schoolFileEditor__publish span { margin-top: 2px; color: var(--text-muted, #64748b); font-size: 12px; }\n\n.schoolFileEditor__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.schoolFileEditor__actions button {\n  min-height: 38px;\n  padding: 0 14px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.schoolFileEditor__actions button.isPrimary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.schoolFileEditor__actions button:disabled { cursor: not-allowed; opacity: 0.55; }\n\n.schoolFilesDeleteModal .modal-footer .btn-primary {\n  border-color: var(--red-600, #c4313f) !important;\n  background: var(--red-600, #c4313f) !important;\n  color: #fff !important;\n}\n\n.schoolFileCategoryDeleteModal .modal-footer .btn-primary {\n  border-color: var(--red-600, #c4313f) !important;\n  background: var(--red-600, #c4313f) !important;\n  color: #fff !important;\n}\n\n.schoolFileCategoryModal .modal-content {\n  overflow: hidden !important;\n  border: 1px solid var(--border-subtle, #e2e8f0) !important;\n  border-radius: 14px !important;\n}\n\n.schoolFileCategoryModal .modal-body {\n  padding: 20px 22px !important;\n  overflow-x: hidden !important;\n}\n\n.schoolFileCategoryModal .modal-body > div,\n.schoolFileCategoryModal__body,\n.schoolFileCategoryModal__body * {\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.schoolFileCategoryModal .modal-footer {\n  gap: 8px !important;\n  padding: 14px 22px !important;\n  border-top: 1px solid var(--border-subtle, #e2e8f0) !important;\n  background: var(--surface-card, #fff) !important;\n}\n\n.schoolFileCategoryModal .modal-footer .btn {\n  min-height: 38px !important;\n  padding: 0 14px !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n}\n\n.schoolFileCategoryModal .modal-footer .btn-secondary:not(:disabled) {\n  border-color: var(--border-default, #cbd5e1) !important;\n  background: var(--surface-card, #fff) !important;\n  color: var(--text-body, #334155) !important;\n}\n\n.schoolFileCategoryModal .modal-footer .btn-secondary:not(:disabled):hover {\n  border-color: var(--border-brand, #6fb1df) !important;\n  background: var(--blue-50, #eef6fc) !important;\n  color: var(--blue-700, #155d8c) !important;\n}\n\n.schoolFileCategoryModal .modal-footer .btn-primary:not(:disabled) {\n  border-color: var(--action-primary, #227ebd) !important;\n  background: var(--action-primary, #227ebd) !important;\n  color: #fff !important;\n}\n\n.schoolFileCategoryModal .modal-footer .btn-primary:not(:disabled):hover {\n  border-color: var(--blue-600, #1a6da3) !important;\n  background: var(--blue-600, #1a6da3) !important;\n}\n\n.schoolFileCategories__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  padding-bottom: 14px;\n}\n.schoolFileCategories__toolbar strong,\n.schoolFileCategories__toolbar span { display: block; }\n.schoolFileCategories__toolbar strong { color: var(--text-strong, #0f172a); font-size: 15px; }\n.schoolFileCategories__toolbar span { margin-top: 3px; color: var(--text-muted, #64748b); font-size: 12px; }\n.schoolFileCategories__toolbar > button {\n  min-height: 38px;\n  padding: 0 14px;\n  border: 1px solid var(--action-primary, #227ebd);\n  border-radius: 8px;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.schoolFileCategories__tableWrap { overflow: visible; border: 1px solid var(--border-subtle, #e2e8f0); border-radius: 10px; }\n.schoolFileCategories table { width: 100%; border-collapse: separate; border-spacing: 0; }\n.schoolFileCategories th { padding: 11px 14px; border-bottom: 1px solid var(--border-subtle, #e2e8f0); background: var(--slate-25, #fafbfc); color: var(--text-muted, #64748b); font-size: 11px; font-weight: 800; text-align: left; text-transform: uppercase; }\n.schoolFileCategories td { height: 56px; padding: 10px 14px; border-bottom: 1px solid var(--border-subtle, #e2e8f0); font-size: 13px; }\n.schoolFileCategories tr:last-child td { border-bottom: 0; }\n.schoolFileCategories tbody tr { cursor: pointer; }\n.schoolFileCategories tbody tr:hover { background: var(--slate-25, #fafbfc); }\n.schoolFileCategories tbody .schoolFileCategories__emptyRow { cursor: default; }\n.schoolFileCategories tbody .schoolFileCategories__emptyRow:hover { background: #fff; }\n.schoolFileCategories td:first-child strong,\n.schoolFileCategories td:first-child small { display: block; }\n.schoolFileCategories td:first-child strong { color: var(--text-strong, #0f172a); }\n.schoolFileCategories td:first-child small { margin-top: 2px; color: var(--text-subtle, #94a3b8); font-size: 10.5px; }\n.schoolFileCategories td:nth-child(2) span { display: inline-flex; padding: 4px 9px; border-radius: 999px; background: var(--surface-sunken, #f1f5f9); color: var(--text-muted, #64748b); font-size: 12px; font-weight: 700; }\n.schoolFileCategories td:nth-child(2) span.isPublished { background: var(--green-50, #edf8f2); color: var(--green-700, #287a50); }\n.schoolFileCategories td:last-child { width: 1%; white-space: nowrap; text-align: right; }\n.schoolFileCategories td:last-child button { min-height: 32px; margin-left: 6px; padding: 0 11px; border: 1px solid var(--border-default, #cbd5e1); border-radius: 8px; background: #fff; color: var(--text-body, #334155); font-size: 12px; font-weight: 700; }\n.schoolFileCategories td:last-child button.isDanger { color: var(--red-600, #c4313f); }\n.schoolFileCategoryModal__body label { display: block; margin: 0; }\n.schoolFileCategoryModal__body label > span { display: block; margin-bottom: 6px; color: var(--text-muted, #64748b); font-size: 12px; font-weight: 700; }\n.schoolFileCategoryModal__body input[type='text'],\n.schoolFileCategoryModal__body label:first-child input { width: 100%; height: 40px; padding: 0 12px; border: 1px solid var(--border-default, #cbd5e1); border-radius: 8px; outline: 0; }\n.schoolFileCategoryModal__body input[type='text']:focus { border-color: var(--border-brand, #6fb1df); box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16)); }\n.schoolFileCategoryModal__visibility { display: flex !important; align-items: center; gap: 10px; margin-top: 16px !important; padding: 12px; border: 1px solid var(--border-subtle, #e2e8f0); border-radius: 9px; background: var(--slate-25, #fafbfc); }\n.schoolFileCategoryModal__visibility > span { margin: 0 !important; }\n.schoolFileCategoryModal__visibility strong,\n.schoolFileCategoryModal__visibility small { display: block; }\n.schoolFileCategoryModal__visibility strong { color: var(--text-strong, #0f172a); font-size: 13px; }\n.schoolFileCategoryModal__visibility small { margin-top: 2px; color: var(--text-muted, #64748b); font-size: 12px; font-weight: 500; }\n\n@media (max-width: 760px) {\n  .schoolFilesPage__header {\n    width: calc(100% + 32px);\n    min-height: 0;\n    align-items: flex-start;\n    flex-direction: column;\n    margin-left: -16px;\n    padding: 16px;\n  }\n\n  .schoolFilesPage .gridModernSearch {\n    width: 100%;\n    flex-basis: 100%;\n  }\n\n  .schoolFilesPage .gridModernFilterPopover {\n    width: 100vw;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
